import React from 'react'
import ContractManagementList from '../../components/contractmanagement/ContractManagementList';

function ContractManagementListPage({ renderPageContent }) {
    return (
        <>
            {/*Dynamic content goes here */}
            <ContractManagementList renderPageContent={renderPageContent} />


        </>
    )
}

export default ContractManagementListPage;